/* src/app/reconciliation/reconciliation-export/reconciliation-export.component.scss */
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header,
body#themeTag :host ::ng-deep .p-datatable .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 5.75em;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header .p-datatable-thead tr.column-filter td input,
body#themeTag :host ::ng-deep .p-datatable .p-datatable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header .p-datatable-thead tr.column-filter td input {
  width: 100%;
  margin: 0 0 0 0.1em;
}
/*# sourceMappingURL=reconciliation-export.component.css.map */
